import React, { useEffect, useState } from "react";
import { Switch, Route, Redirect, Link } from "react-router-dom";

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

import axiosModificado from "components/ConfiguracionAxios";
import Swal from "sweetalert2";
import CardStatsSimple from "components/Cards/CardStatsSimple";

import { useVerifyUser } from "helpers/verifyUser";
import "./styleColaborador.css";
import SidebarColaborador from "components/Sidebar/SidebarColaborador";

import { useParams } from "react-router-dom/cjs/react-router-dom.min";

export default function ColaboradorDashboard() {
    const user = useVerifyUser();
    console.log('Renderizando Componente');

    const [ horasDiurnas, sethorasDiurnas ] = useState(0);
    const [ horasNocturnas, sethorasNocturnas ] = useState(0);

    useEffect(() => {
        // Evita peticiones con id indefinido durante el primer render.
        console.trace('useEffect disparado, id_user:', user?.id_user);
        if (!user?.id_user) return;

        let isMounted = true;

        Promise.all([
            axiosModificado.get(`/usuario/horasTrabajadasDiurnasEnElDia/${user.id_user}`),
            axiosModificado.get(`/usuario/horasTrabajadasNocturnasEnElDia/${user.id_user}`),
        ])
        .then(([diurnasResponse, nocturnasResponse]) => {
            if (!isMounted) return;

            if (Object.keys(diurnasResponse.data).length === 0) {
                sethorasDiurnas(0);
            } else {
                sethorasDiurnas(diurnasResponse.data);
            }

            if (Object.keys(nocturnasResponse.data).length === 0) {
                sethorasNocturnas(0);
            } else {
                sethorasNocturnas(nocturnasResponse.data);
            }
        })
        .catch(error => {
            if (!isMounted) return;
            Swal.fire('Error', 'Error al cargar las horas del dia, recargue la pagina.', 'error');
            console.error('Error al obtener datos de la API:', error);
        });

        return () => {
            isMounted = false;
        };
    }, [user?.id_user]);

    return (
        <>
            <SidebarColaborador />
            <div className="relative md:ml-64 bg-blueGray-100">
                <AdminNavbar />
                <div className="relative bg-lightBlue-600 md:pt-32 pb-32 pt-12">
                    <div className="px-4 md:px-10 mx-auto w-full">
                        <div>
                            {/* Card stats */}
                            <div className="flex flex-wrap">
                                <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                                <CardStatsSimple 
                                    statSubtitle="Horas Diurnas Hoy"
                                    statTitle={String(horasDiurnas)}
                                    statIconName="far fa-clock"
                                    statIconColor="bg-amber-400"
                                />
                                </div>
                                <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                                <CardStatsSimple 
                                    statSubtitle="Horas Nocturnas Hoy"
                                    statTitle={String(horasNocturnas)}
                                    statIconName="far fa-clock"
                                    statIconColor="bg-blueGray-600"
                                />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="px-4 md:px-10 mx-auto w-full">
                    <FooterAdmin />
                </div>
            </div>
        </>
    );
}
